import type { ReactNode } from "react";
import { Box, Typography } from "@mui/material";

export function HomeSection({
  id,
  title,
  description,
  children
}: {
  id: string;
  title: string;
  description: string;
  children: ReactNode;
}) {
  return (
    <Box
      component="section"
      id={id}
      aria-labelledby={`${id}-title`}
      sx={{
        maxWidth: 1200,
        mx: "auto",
        px: { xs: 2, sm: 3 },
        py: { xs: 5, md: 7 },
        borderTop: 1,
        borderColor: "divider",
        scrollMarginTop: 3
      }}
    >
      <Typography id={`${id}-title`} variant="h2" sx={{ mb: 1 }}>
        {title}
      </Typography>
      <Typography color="text.secondary" sx={{ mb: 3, maxWidth: "60ch" }}>
        {description}
      </Typography>
      {children}
    </Box>
  );
}
